import { render } from "./Andigit.vue?vue&type=template&id=9364d698"
import script from "./Andigit.vue?vue&type=script&lang=js"
export * from "./Andigit.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrien/perso/Projets/new-portfolio/vuejs-tailwind-portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__